/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  Bank
} from '../../schema'


/**
 * Get Bank details
 */
export const retrieveBank = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Bank>> => {
    return axios.get(
      `/bank/${id}`,options
    );
  }


export const getRetrieveBankQueryKey = (id: string,) => [`/bank/${id}`];

    
export type RetrieveBankQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveBank>>>
export type RetrieveBankQueryError = AxiosError<unknown>

export const useRetrieveBank = <TData = Awaited<ReturnType<typeof retrieveBank>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveBank>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRetrieveBankQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveBank>>> = ({ signal }) => retrieveBank(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof retrieveBank>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Update Bank details
 */
export const updateBank = (
    id: string,
    bank: Bank, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Bank>> => {
    return axios.put(
      `/bank/${id}`,
      bank,options
    );
  }



    export type UpdateBankMutationResult = NonNullable<Awaited<ReturnType<typeof updateBank>>>
    export type UpdateBankMutationBody = Bank
    export type UpdateBankMutationError = AxiosError<unknown>

    export const useUpdateBank = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBank>>, TError,{id: string;data: Bank}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBank>>, {id: string;data: Bank}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBank(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof updateBank>>, TError, {id: string;data: Bank}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Delete a Bank
 */
export const destroyBank = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/bank/${id}`,options
    );
  }



    export type DestroyBankMutationResult = NonNullable<Awaited<ReturnType<typeof destroyBank>>>
    
    export type DestroyBankMutationError = AxiosError<unknown>

    export const useDestroyBank = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyBank>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyBank>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyBank(id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof destroyBank>>, TError, {id: string}, TContext>(mutationFn, mutationOptions)
    }
    